import { atomWithReset } from 'jotai/utils';

import { FollowupMessageSettingModal } from './types';

export const followupMessageSettingModalState = atomWithReset<FollowupMessageSettingModal>({
  isOpen: false,
  patientId: null,
  guestPatientId: null,
});
